import { getDisplayDifficulty } from './difficultyFromContent'
import { getDifficultyTryOrder } from './parcoursDifficultySequence'

function pickPoolByDifficultyOrder(pool, tryOrder) {
  if (!Array.isArray(tryOrder) || tryOrder.length === 0) return null
  for (const diff of tryOrder) {
    const atDifficulty = pool.filter((ex) => getDisplayDifficulty(ex.metadata?.difficulty) === diff)
    if (atDifficulty.length > 0) return atDifficulty
  }
  return null
}

/**
 * Pool pour tirage aléatoire parcours : plafond d'étage d'abord, puis non faits,
 * puis reprise si tout est fait (en évitant le dernier exercice du nœud si possible).
 * @param {Array} suitableExercises
 * @param {{ allowed: string[], preferred: string, doneExerciseIds?: string[], excludeExerciseId?: string|null }} options
 * @returns {Array|null}
 */
export function pickParcoursRandomPool(suitableExercises, { allowed, preferred, doneExerciseIds, excludeExerciseId }) {
  const ceilingPool = pickPoolByDifficultyOrder(
    suitableExercises,
    getDifficultyTryOrder(preferred, allowed)
  )
  if (!ceilingPool?.length) return null

  const doneSet =
    Array.isArray(doneExerciseIds) && doneExerciseIds.length > 0 ? new Set(doneExerciseIds) : null

  let pool = doneSet ? ceilingPool.filter((ex) => !doneSet.has(ex.id)) : ceilingPool

  // Tous les exercices du plafond sont déjà faits : autoriser la reprise
  if (pool.length === 0) {
    pool = ceilingPool
  }

  if (excludeExerciseId && pool.length > 1) {
    const withoutLast = pool.filter((ex) => ex.id !== excludeExerciseId)
    if (withoutLast.length > 0) pool = withoutLast
  }

  return pool
}
